export default {
	methods: {
		/**
		 *
		 * Triggers a download of the given data as a file using a temporary object URL.
		 *
		 * Creates a Blob from the provided data, generates a temporary URL for it,
		 * and programmatically clicks a hidden anchor element to prompt the user to download the file.
		 * The object URL is revoked afterward to free memory.
		 *
		 *  @function
		 *  @param {BlobPart|BlobPart[]} data - The data to be downloaded. Can be a single BlobPart (e.g., string, ArrayBuffer) or an array.
		 *  @param {string} filename - The desired name of the downloaded file (e.g., "report.csv").
		 *
		 *  @example
		 *  downloadBlob("name,age\nAlice,30", "users.csv");
		 */
		downloadFile(data, filename) {
			const isXlsx = filename.endsWith('.xlsx');
			const type = isXlsx ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'text/csv;charset=utf-8;';
			const BOM = new Uint8Array([0xef, 0xbb, 0xbf]);
			const blob = isXlsx ? new Blob([data], { type }) : new Blob([BOM, data], { type });
			const url = window.URL.createObjectURL(blob);

			try {
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', filename);
				document.body.appendChild(link);
				link.click();
				if (link.parentNode) {
					link.remove();
				}
			} finally {
				window.URL.revokeObjectURL(url);
			}
		},
		downloadFromUrl(href) {
			const link = document.createElement('a');
			link.href = href;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},
		downloadFromUrlWithFilename(href, filename) {
			try {
				const link = document.createElement('a');
				link.href = href;
				link.setAttribute('download', filename);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			} catch (error) {
				window.URL.revokeObjectURL(href);
			}
		},
	},
};
